/**
 * Return the difference between two date
 * @param Date input
 * @param Date today or compareDate
 * @param String units, must be year, month, week, day
 * @returns int
 */

import { format } from 'date-fns';

export const diff = (input, today, units) => {
	let output;

	if (input.getTime() > today.getTime()) {
		return diff(today, input, units);
	}
	// **** utils ****
	const removeTime = (date = new Date()) => {
		return new Date(date.getFullYear(), date.getMonth(), date.getDate());
	};

	const yearDiff = (d1, d2) => {
		return d2.getFullYear() - d1.getFullYear();
	};

	const isSameWeek = (d1, d2) => {
		let date2 = new Date(d2);
		let first = new Date(date2.setDate(date2.getDate() - date2.getDay()));
		let last = new Date(first);
		last.setDate(last.getDate() + 6);

		return d1 >= first && d1 <= last;
	};

	const weekOfYear = date => {
		var jan1 = new Date(date.getFullYear(), 0, 1);
		return Math.ceil(((date - jan1) / 86400000 + jan1.getDay() + 1) / 7);
	};

	// **** utils ****

	input = removeTime(input);
	today = removeTime(today);

	switch (units) {
		case 'year':
			output = yearDiff(input, today);
			break;
		case 'month':
			output = yearDiff(input, today) * 12;
			output -= input.getMonth();
			output += today.getMonth();
			break;
		case 'week':
			switch (true) {
				case isSameWeek(input, today):
					output = 0;
					break;
				case diff(input, today, 'month') === 1 &&
					weekOfYear(input) === 53:
					output = Math.abs(weekOfYear(today) - 1);
					break;
				default:
					output =
						53 * yearDiff(input, today) +
						Math.abs(weekOfYear(input) - weekOfYear(today));
					break;
			}
			break;
		default:
			//day
			output = (today - input) / 864e5; // 1000 * 60 * 60 * 24
			break;
	}

	return Math.round(output);
};

import { abbrZone } from '@/utils/date/toLocaleString';

export const timeAndTimeZone = value => {
	const date = new Date(value);
	let hours = date.getHours();
	let minutes = date.getMinutes();
	let seconds = date.getSeconds();

	let timeZone = date
		.toLocaleDateString('en-US', { timeZoneName: 'short' })
		.split(' ')[1];

	let amPm = hours >= 12 ? 'PM' : 'AM';

	hours = hours % 12;
	hours = hours ? hours : 12;

	minutes = String(minutes).padStart(2, '0');
	seconds = String(seconds).padStart(2, '0');

	return `${hours}:${minutes}:${seconds} ${amPm} ${abbrZone(timeZone)}`;
};

export const formatDate = date => {
	return date ? format(new Date(date), 'MM-dd-yyyy') : undefined;
};

export const tryDecodeURIComponent = value => {
	let decodedDate;

	try {
		decodedDate = decodeURIComponent(value);
	} catch (error) {
		decodedDate = undefined;
	}
	return decodedDate;
};
